import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOrganizationFilledmin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.667 4.667H8V2H1.333v12h13.334V4.667ZM4 12.667H2.667v-1.334H4v1.334ZM2.667 10H4V8.667H2.667V10ZM4 7.333H2.667V6H4v1.333ZM2.667 4.667H4V3.333H2.667v1.334Zm4 8H5.333v-1.334h1.334v1.334ZM5.333 10h1.334V8.667H5.333V10Zm1.334-2.667H5.333V6h1.334v1.333ZM5.333 4.667h1.334V3.333H5.333v1.334ZM12 7.333h-1.333v1.334H12V7.333ZM10.667 10H12v1.333h-1.333V10ZM8 7.333h1.333v1.334H8V7.333ZM9.333 10H8v1.333h1.333V10Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgOrganizationFilledmin);
export { ForwardRef as ReactComponent };
